import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { CalendarEventReminder } from "../../Calendars/Models/Domain";
import type { CalendarEventReminderApi } from "../../Calendars/Models/Api";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";
import { snake } from "@/Utils/Snakelize";

const CalendarEventReminderTransformer: TransformerExtended<CalendarEventReminder, CalendarEventReminderApi> =
  {
    ...DefaultTransformerGenerator<CalendarEventReminder, CalendarEventReminderApi>(),

    toDomain(input: CalendarEventReminderApi): CalendarEventReminder {
      return camel(input);
    },

    toApi(input: CalendarEventReminder): CalendarEventReminderApi {
      return snake(input);
    },
  };

export type CalendarEventReminderTransformerType = TransformerExtended<
  CalendarEventReminder,
  CalendarEventReminderApi
>;

export default CalendarEventReminderTransformer;
